import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';

import { ClientType } from 'src/constants';
import { OnboardingLoginFormValues } from 'src/legacy/components/Onboarding/OnboardingForms';
import { IndustryOptionType } from 'src/routes/onboarding/setup/components/about-your-company/constants';

const ONBOARDING_STEPS = [
  'create-account',
  'login-challenge',
  'company-setup',
  'about-your-company',
  'who-you-serve',
  'customize-your-workspace',
] as const;

export type OnboardingStep = (typeof ONBOARDING_STEPS)[number];

export function isOnboardingStep(
  step: string | undefined,
): step is OnboardingStep {
  return ONBOARDING_STEPS.includes(step as OnboardingStep);
}

export type TrackedEventsType = Partial<Record<OnboardingStep, boolean>>;

export interface OnboardingQueryParams {
  referred?: string;
  source?: string;
  prefill_email?: string;
  name?: string;
  template_id?: string;
  template_name?: string;
  step?: string;
  authSource?: CognitoHostedUIIdentityProvider;
}

export interface OnboardingFormValues extends OnboardingLoginFormValues {
  referred?: string;
  source?: string;
  name: string;
  phone: string;
  foundBy: string;
  foundByCustom: string;
  companyName: string;
  portalUrl: string;
  industry: IndustryOptionType | '';
  industryLabel: string;
  companySize: string;
  companySizeLabel: string;
  signoutRedirectURL: string;
  anonymousId: string;
  clientType: ClientType | '';
  clientTypeLabel: string;
  clientCount: string;
  clientCountLabel: string;
  // used for google auth to represent the auth provider
  loginSource?: CognitoHostedUIIdentityProvider;
  picture?: string;
  workspaceTemplateId?: string;
  companyAge: string;
  companyAgeLabel: string;
  clientSource: string;
  clientSourceLabel: string;
  companyRevenue: string;
  companyRevenueLabel: string;
  priorities: string[];
  prioritiesLabels: string;
  enabledFeatures: string[];
  isAssemblyBrandEnabled: boolean;
  challengeResponse: string;
}

type RemoveProperties<T, K extends keyof T> = Omit<T, K> & {
  [P in K]?: never;
};

/**
 * This interface corresponds directly to the data being passed to the call to /portal/any/setup.
 * This ensures that any data the BE doesn't need will have to be removed before the call is made.
 */
export type PortalSetupInput = RemoveProperties<
  OnboardingFormValues,
  | 'foundByCustom' // only used in the FE for user-defined foundBy values, if it has a value it's passed to the BE in foundBy
  | 'challengeResponse' // only used for an auth challenge like MFA
>;
